import React from 'react';
import LegalPage from './LegalPage';

const H = ({ children }) => (
  <h2 className="text-[#242326] text-xl md:text-2xl font-medium font-['Inter'] mt-10 mb-3 first:mt-0">
    {children}
  </h2>
);

const Terms = () => (
  <LegalPage title="Terms &amp; Conditions" lastUpdated="29 April 2026" testid="terms-page">
    <H>About these Terms</H>
    <p>
      Welcome to Grouth. These Terms &amp; Conditions (&ldquo;Terms&rdquo;) govern your access to and use of
      the website operated by Grouth Marketing Limited (&ldquo;Grouth&rdquo;, &ldquo;we&rdquo;,
      &ldquo;our&rdquo;, &ldquo;us&rdquo;) at{' '}
      <a href="https://www.grouth.co" className="text-[#83BF42] underline">www.grouth.co</a> and any related
      content, tools or services we make available (collectively, the &ldquo;Service&rdquo;). By accessing or
      using the Service you agree to be bound by these Terms. If you do not agree, do not use the Service.
    </p>

    <H>Who we are</H>
    <p>
      Grouth Marketing Limited is a company registered in Lagos, Nigeria. Our office is at Plot 1 Block,
      Marwa Bus Stop, 128 Remi Olowude St, Lekki Phase I 105102, Lekki. You can reach us at{' '}
      <a href="mailto:ademola@grouth.co" className="text-[#83BF42] underline">ademola@grouth.co</a> or{' '}
      <a href="tel:+2348117398259" className="text-[#83BF42] underline">+234 (0) 8117398259</a>.
    </p>

    <H>Use of the Service</H>
    <p>
      You may use the Service only for lawful purposes and in accordance with these Terms. In particular, you
      agree not to:
    </p>
    <ul className="list-disc pl-6 space-y-2">
      <li>Use the Service in any way that breaches any applicable local, national or international law or regulation.</li>
      <li>Attempt to gain unauthorised access to the Service, its servers, or any system or network connected to it.</li>
      <li>Use any automated system (including bots, scrapers, or harvesters) to access the Service in a way that sends more requests in a given period than a human could reasonably produce.</li>
      <li>Reproduce, duplicate, copy, sell or otherwise commercially exploit any part of the Service without our prior written consent.</li>
    </ul>

    <H>Intellectual property</H>
    <p>
      All content on this Service — including text, graphics, logos, icons, images, audio clips, video clips,
      data compilations, and software — is the property of Grouth or its content suppliers and is protected by
      Nigerian and international intellectual-property laws. The compilation of all content on this Service
      is the exclusive property of Grouth.
    </p>
    <p>
      You may print or download extracts from the Service for your personal, non-commercial reference. Any
      other use, including reproduction, modification, distribution, or republication, without our prior
      written permission, is strictly prohibited.
    </p>

    <H>Forms, enquiries and contact submissions</H>
    <p>
      When you submit information through any form on the Service (including the contact form and newsletter
      signup), you confirm that the information provided is accurate. We use the information you submit to
      respond to your enquiry, manage our relationship with you, and as further described in our{' '}
      <a href="/privacy" className="text-[#83BF42] underline">Privacy Policy</a>. You are responsible for
      keeping any information you provide up to date.
    </p>

    <H>Newsletter and email</H>
    <p>
      If you opt-in to our newsletter, you may unsubscribe at any time using the link at the bottom of every
      email or by visiting the unsubscribe link we send you. We use{' '}
      <a href="https://resend.com" className="text-[#83BF42] underline" rel="noopener noreferrer" target="_blank">Resend</a>{' '}
      to deliver our emails; their privacy practices are set out on their site.
    </p>

    <H>Third-party links</H>
    <p>
      The Service may contain links to third-party websites or resources that are not owned or controlled by
      Grouth. We have no control over, and assume no responsibility for, the content, privacy policies, or
      practices of any third-party site or service. You acknowledge and agree that we shall not be
      responsible or liable for any damage or loss caused or alleged to be caused by or in connection with
      the use of any such third-party content.
    </p>

    <H>Disclaimers</H>
    <p>
      The Service is provided on an &ldquo;as is&rdquo; and &ldquo;as available&rdquo; basis. To the fullest
      extent permitted by law, Grouth makes no representations or warranties of any kind, express or implied,
      regarding the operation of the Service or the information, content, materials, or products included on
      the Service. Any insights, articles or case studies are provided for informational purposes only and do
      not constitute professional or financial advice.
    </p>

    <H>Limitation of liability</H>
    <p>
      To the fullest extent permitted by applicable law, Grouth, its officers, directors, employees, agents
      and affiliates shall not be liable for any direct, indirect, incidental, special, consequential or
      exemplary damages arising out of or in connection with your use of the Service, even if advised of the
      possibility of such damages.
    </p>

    <H>Changes to the Service or these Terms</H>
    <p>
      We reserve the right to modify or discontinue, temporarily or permanently, the Service (or any part of
      it) at any time, with or without notice. We may also revise these Terms from time to time. The most
      current version will always be available on this page. Your continued use of the Service after any
      change constitutes your acceptance of the new Terms.
    </p>

    <H>Governing law</H>
    <p>
      These Terms are governed by and construed in accordance with the laws of the Federal Republic of
      Nigeria. Any dispute arising out of or in connection with these Terms shall be subject to the exclusive
      jurisdiction of the courts of Lagos State, Nigeria.
    </p>

    <H>Contact</H>
    <p>
      Questions about these Terms? Email{' '}
      <a href="mailto:ademola@grouth.co" className="text-[#83BF42] underline">ademola@grouth.co</a>.
    </p>
  </LegalPage>
);

export default Terms;
